<template>
  <header>
    <nav class="navbar navbar-expand-md">
      <div class="container-fluid">
        <router-link to="/Home" class="navbar-brand">
          <img src="https://snippcheck.blob.core.windows.net/files/pg_clean_and_save_2008123/brand-logo.png" alt="P&G Professional logo" class="img-fluid" />
        </router-link>
        <div class="langtoggle">
          <button @click="changeLanguage('en-CA')" :class="{ active: currentLang === 'en-CA' }">EN</button>
          <button @click="changeLanguage('fr-CA')" :class="{ active: currentLang === 'fr-CA' }">FR</button>
        </div>
      </div>
    </nav>
  </header>

  <banner></banner>
</template>


<script>
import banner from '../UI/Banner.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted } from 'vue';
import { loadLocaleMessages } from '@/main.js';

export default {
  components: { banner },
  setup() {
    const { locale, t } = useI18n();
    const currentLang = ref(locale.value);
    const isCollapsed = ref(false); // ✅ Define state for toggle

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
    };

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      await loadLocaleMessages(lang);
      locale.value = lang;
      localStorage.setItem('locale', lang);
      currentLang.value = lang;

      document.documentElement.lang = lang; // ✅ Update <html lang="">

      injectGTM();
      injectCookieScript(lang); // Fetch the script based on the selected language
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
      
    });

    onMounted(() => {
      document.documentElement.lang = currentLang.value; // ✅ Set lang on page load

      injectGTM();
      injectCookieScript(currentLang.value); // Load script for the initial language
    });

    const injectGTM = () => {
      const gtmId = t('gtmId');
      if (!gtmId) return;

      document.querySelectorAll("[data-gtm]").forEach(el => el.remove());

      const script = document.createElement("script");
      script.setAttribute("data-gtm", gtmId);
      script.innerHTML = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; 
          j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; 
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmId}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.setAttribute("data-gtm", gtmId);
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.prepend(noscript);
    };

    // Fetch `cookieScript` from JSON and Inject
    const injectCookieScript = async (lang) => {
  try {
    const response = await fetch(`/locales/${lang}.json`);
    
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    console.log(`Fetched JSON for ${lang}:`, data); // ✅ Debug log

    const cookieScript = data?.Header?.cookieScript; // Extract cookieScript from JSON
    console.log(`Extracted cookieScript:`, cookieScript); // ✅ Debug log

    if (!cookieScript) {
      console.warn(`cookieScript not found in JSON for ${lang}`);
      return;
    }

    // Remove existing script to prevent duplicates
    document.querySelectorAll("[data-cookie-script]").forEach(el => el.remove());

    // Inject script
    const script = document.createElement("script");
    script.setAttribute("data-cookie-script", lang);
    script.textContent = cookieScript; // ✅ Inject script from JSON
    document.head.appendChild(script);

    console.log(`cookieScript injected successfully`);
  } catch (error) {
    console.error(`Error loading CookieScript for ${lang}:`, error);
  }
};


    return { currentLang, changeLanguage, isCollapsed, toggleCollapse }; // ✅ Return toggle function
  },
};
</script>
